import { useContext, useMemo } from 'react';
import { Skeleton, Stack, Text } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { CustomAttributesContext } from '../../../Service/Context/CustomAttributeContext';
import { EventContext } from '../../../Service/Context/EventContext';
import CustomAttributeGroup from './CustomAttributeGroup';

const EventCustomAttributeList = ({ customAttributeFormatter }) => {
  const { id: eventId } = useParams();
  const { attributeGroups, refreshGroups, refreshValue } = useContext(CustomAttributesContext);

  const { event } = useContext(EventContext);
  const { kindId } = event ?? { kindId: null };

  const filteredGroups = useMemo(() => {
    if (!attributeGroups) return [];
    return attributeGroups.filter((g) => {
      const { kindsOfInterest } = g;
      return !(kindsOfInterest && kindsOfInterest.length > 0 && kindId && !kindsOfInterest.includes(kindId));
    });
  }, [attributeGroups, kindId]);

  if (!attributeGroups) {
    return <Skeleton width="100%" height={50} />;
  }

  return (
    <div>
      {filteredGroups.length === 0 ? (
        <Text italic color="dimmed" size="xs" weight="lighter">
          {attributeGroups.length === 0
            ? 'Noch nichts hinzugefügt.'
            : 'Der ausgewählten Event-Art sind keine eigenen Felder zugeordnet.'}
        </Text>
      ) : (
        <Stack spacing={5}>
          {filteredGroups.map((group) => (
            <CustomAttributeGroup
              key={group.id}
              group={group}
              entityType="events"
              entityId={eventId}
              customAttributeFormatter={customAttributeFormatter}
              attributeGroups={attributeGroups}
              refreshGroups={refreshGroups}
              refreshValue={refreshValue}
            />
          ))}
        </Stack>
      )}
    </div>
  );
};

export default EventCustomAttributeList;
